import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'lift_c5_newspaper',
    label: 'LIFT_C5_Newspaper',
    flowVariables: [
        { name: 'heading', label: 'Headline Response', type: 'string' },
        { name: 'story', label: 'Story Response', type: 'string' },
    ],
    builderInitialValues,
    builder: Builder,
    player: Player,
};
